import './Partners.css'
import api from '../api.js';
import { useEffect, useState } from "react";
import cross from "../imgs/cross.svg";
import plus from "../imgs/plus.svg";
import { useLocation } from "react-router-dom";
import edit from "../imgs/pen.svg";
import lupa from "../imgs/lupa.svg";
import { fmtDateTime } from '../utils/format';

export default function Partners() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const partnerCodePassed = queryParams.get("code");

    const [newPartnerName, setNewPartnerName] = useState("");
    const [partners, setPartners] = useState([]);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPartner, setSelectedPartner] = useState(null);
    const [editedPartnerName, setEditedPartnerName] = useState("");
    const [editedPartnerApp, setEditedPartnerApp] = useState("");
    const [editedPartnerApiKey, setEditedPartnerApiKey] = useState("");

    const [modalError, setModalError] = useState("");
    const [modalMessage, setModalMessage] = useState("");

    const [partnerToSearch, setPartnerToSearch] = useState("");
    const [placeholderError, setPlaceholderError] = useState("");

    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

    const [newPartnerApp, setNewPartnerApp] = useState("");
    const [newPartnerApiKey, setNewPartnerApiKey] = useState("");

    const [partnerApp, setPartnerApp] = useState("");
    const [partnerApiKey, setPartnerApiKey] = useState("");

    const [processing, setProcessing] = useState(false);


    const fetchPartners = async () => {
        setError("");
        try {
            const token = localStorage.getItem("token");
            const res = await api.get("/api/partners/list", {
                // headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            setPartners(res.data);

        } catch (err) {
            if (err.response?.status === 401) {
                setError("Токен недействителен или истёк. Перелогиньтесь.");
                localStorage.removeItem("token");
                window.location.href = "/login";
            }
            else if (err.response.status === 500) {
                setError("");
            }
            else {
                setError("Ошибка при загрузке партнеров");
            }
        }
    };

    useEffect(() => {
        document.title = "Партнеры - WAve";

        const queryParams = new URLSearchParams(location.search);
        const partnerCode = queryParams.get("code");

        if (partnerCode) {
            handleSearchByCode(null, partnerCode);
            setPartnerToSearch(partnerCode); // чтобы input обновился
        } else {
            fetchPartners();
        }
    }, [location.search]);

    const handleCreatePartner = async (e) => {
        e.preventDefault();
        setMessage("");
        setError("");
        setProcessing(true);

        try {
            const res = await api.post("/api/partners/create-partner", {
                name: newPartnerName,
                app_id: newPartnerApp,
                gupshup_api_key: newPartnerApiKey
            });

            if (res.status === 200) {
                setMessage("Партнер успешно создан");
                fetchPartners();
            }

            setNewPartnerName("");
            setNewPartnerApiKey("");
            setNewPartnerApp("");
            setProcessing(false);
        } catch (err) {
            setError(
                err?.response?.data?.message || "Ошибка при создании партнера"
            );
            setProcessing(false);
        }
    };

    const handleDisablePartner = async (partnerName) => {
        try {
            const token = localStorage.getItem("token");
            await api.patch(
                "/api/partners/disable",
                null,
                {
                    params: { partnerName }
                    // headers: token ? { Authorization: `Bearer ${token}` } : {}
                }
            );

            fetchPartners();
        } catch (err) {
            if (err.response.status === 403) {
                setError("Отсутствует право отключать партнеров")
            }
            else {
                setError("Ошибка при отключении партнера");
            }
        }
    };

    const openModal = (partner) => {
        setSelectedPartner(partner);
        setEditedPartnerName(partner.name);
        setEditedPartnerApp(partner.app_id);
        setModalError("");
        setModalMessage("");
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedPartner(null);
        setEditedPartnerApiKey('');
        setEditedPartnerApp('');
        setModalError('');
        setModalMessage('');
        setError('');
        setMessage('');
    };

    const handleEditPartner = async (e) => {
        e.preventDefault();
        setModalError("");
        setModalMessage("");
        setProcessing(true);

        try {
            const token = localStorage.getItem("token");

            const res = await api.patch(
                "/api/partners/edit",
                null,
                {
                    params: {
                        partnerName: selectedPartner.name,
                        newPartnerName: editedPartnerName,
                        GSAppId: editedPartnerApp,
                        GSApiKey: editedPartnerApiKey
                    }
                    // headers: token ? { Authorization: `Bearer ${token}` } : {}
                }
            );

            if (res.status === 200) {
                setModalMessage("Партнер обновлён");
                setEditedPartnerApiKey("");
                setEditedPartnerApp("");
                fetchPartners();
            }

            setProcessing(false);
        } catch (err) {
            if (err.response.status === 403) {
                setModalError("Отсутствует право редактировать партнеров")
            }
            else {
                setModalError("Ошибка редактирования");
            }

            setProcessing(false);
        }
    };

    const handleSearchByCode = async (e, code) => {
        if (e?.preventDefault) e.preventDefault();

        const searchCode = code || partnerToSearch; // если передан параметр, используем его
        setError("");

        if (searchCode === null || searchCode === "") {
            fetchPartners();
        }

        try {
            const res = await api.get("/api/partners/find-partner", {
                params: { partnerCode: searchCode.trim() },
            });
            setPartners([res.data]);
        } catch (err) {
            const status = err.response?.status;
            if (status === 403) setError("Отсутствует право поиска партнеров");
            else if (status === 404) {
                setError("Партнер не найден");
                setPartners([]);
            } else setError("Ошибка поиска партнера");
        }
    };

    const closeCreateModal = async () => {
        setIsCreateModalOpen(false);
        setNewPartnerName("");
        setNewPartnerApiKey("");
        setNewPartnerApp("");
        setError('');
        setMessage('');
    }


    const me = JSON.parse(localStorage.getItem("me") || "{}");

    return (
        <div className='partners-main'>
            <div className='topRow'>
                <button className='createPartner' onClick={() => setIsCreateModalOpen(true)}><p>Создать партнера</p><img src={plus} /></button>
            </div>
            <div className="partnerSearchBarMobile">
                <input
                    placeholder="Поиск партнера"
                    value={partnerToSearch}
                    onChange={(e) => setPartnerToSearch(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") handleSearchByCode(e);
                    }}
                />
                <button className="searchBtnMobile" onClick={handleSearchByCode}>
                    <img src={lupa} alt="Поиск" />
                </button>
            </div>
            <div className="tableWrapperPartners">
                <table>
                    <thead>
                        <tr>
                            <th><p>Название</p></th>
                            <th>Код</th>
                            <th>Статус</th>
                            <th>Создан</th>
                            <th></th>
                        </tr>
                    </thead>
                    {placeholderError ||
                        <tbody>
                            {partners.map((p, index) => (
                                <tr key={index}>
                                    <td><p>{p.name}</p></td>
                                    <td>{p.code}</td>
                                    <td>
                                        <button
                                            className={p.status !== "Деактивирован" ? "status-button" : "status-button-disabled"}
                                            disabled={p.status === "Деактивирован"}
                                            onClick={() => handleDisablePartner(p.name)}
                                            onMouseEnter={(e) => {
                                                if (p.status !== "Деактивирован") {
                                                    e.currentTarget.innerText = "Деактивировать";
                                                }
                                                else {
                                                    e.currentTarget.innerText = "Деактивирован";
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                if (p.status !== "Деактивирован") {
                                                    e.currentTarget.innerText = p.status;
                                                }
                                            }}

                                        >
                                            {p.status}
                                        </button>

                                    </td>

                                    <td className="nowrap">
                                        {p.createdAt
                                            ? fmtDateTime(p.createdAt)
                                            : "-"}
                                    </td>
                                    <td>
                                        <button className='editPartner' onClick={() => openModal(p)}>
                                            Редактировать
                                        </button>
                                        <button className='editPartnerMobile' onClick={() => openModal(p)}>
                                            <img src={edit} />
                                        </button>
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    }
                </table>
            </div>
            {
                isModalOpen && (
                    <div className="modalOverlay">
                        <div className="modalPartners">
                            {/* <h3>Редактирование партнёра</h3> */}

                            <form onSubmit={handleEditPartner}>
                                {/* <label>Название партнёра</label>
                                <input
                                    value={editedPartnerName}
                                    onChange={e => setEditedPartnerName(e.target.value)}
                                    required
                                />
                                <label>Приложение</label>
                                <input
                                    type="text"
                                    value={editedPartnerApp}
                                    onChange={(e) => setEditedPartnerApp(e.target.value)} />

                                <label>Ключ API</label>
                                <input
                                    type="text"
                                    value={editedPartnerApiKey}
                                    onChange={(e) => setEditedPartnerApiKey(e.target.value)} />

                                {modalMessage && <p className="success">{modalMessage}</p>}
                                {modalError && <p className="error">{modalError}</p>}

                                <button type="submit">Сохранить</button>
                                <button type="button" onClick={closeModal}>Отмена</button> */}
                                <div className='modalTop'>
                                    <h3>Редактирование партнера</h3>
                                    <button type="button" onClick={closeModal}></button>
                                </div>
                                <input
                                    type="text"
                                    placeholder='Название'
                                    value={editedPartnerName}
                                    onChange={(e) => setEditedPartnerName(e.target.value)}
                                />
                                <input
                                    type="text"
                                    placeholder='Приложение'
                                    value={editedPartnerApp}
                                    onChange={(e) => setEditedPartnerApp(e.target.value)} />
                                <input
                                    type="text"
                                    placeholder='Ключ API'
                                    value={editedPartnerApiKey}
                                    onChange={(e) => setEditedPartnerApiKey(e.target.value)}
                                />
                                {modalMessage && <p className="success">{modalMessage}</p>}
                                {modalError && <p className="error">{modalError}</p>}
                                <div className='buttonsModal'>
                                    <button disabled={processing} type="submit" className='saveChangesPartners'>Сохранить</button>
                                    <button disabled={processing} type="button" className='cancelPartners' onClick={closeModal}>Отмена</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )
            }

            {isCreateModalOpen &&
                (
                    <div className="modalOverlay">
                        <div className="modalPartners">
                            <form onSubmit={handleCreatePartner}>
                                <div className='modalTop'>
                                    <h3>Создать нового партнера</h3>
                                    <button type="button" onClick={closeCreateModal}></button>
                                </div>
                                <input
                                    required
                                    type="text"
                                    placeholder='Название'
                                    value={newPartnerName}
                                    onChange={(e) => setNewPartnerName(e.target.value)}
                                />
                                <input required
                                    type="text"
                                    placeholder='Приложение'
                                    value={newPartnerApp}
                                    onChange={(e) => setNewPartnerApp(e.target.value)} />
                                <input required
                                    type="text"
                                    placeholder='Ключ API'
                                    value={newPartnerApiKey}
                                    onChange={(e) => setNewPartnerApiKey(e.target.value)} />
                                {message && <p className="success">{message}</p>}
                                {error && <p className="error">{error}</p>}
                                <div className='buttonsModal'>
                                    <button disabled={processing} type="submit" className='saveChangesPartners'>Создать партнера</button>
                                    <button disabled={processing} type="button" className='cancelPartners' onClick={closeCreateModal}>Отмена</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )
            }

        </div >
    );
}
